/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Button } from "@/components/ui/button";
import CustomDropDown from "@/components/common/CustomDropDown";
import { MessageAndInstructions } from "@/components/product/details/ProductDetailView/sections";
const ProductForm = t0 => {
  const $ = _c(30);
  const {
    product,
    formData,
    toggleEggless,
    handleFlavorChange,
    handleMessageChange,
    handleCustomizedNameChange,
    availableFlavors,
    children
  } = t0;
  let t1;
  if ($[0] !== availableFlavors || $[1] !== product?.has_eggless_option || $[2] !== product?.is_theme_cake) {
    t1 = (product?.has_eggless_option || product?.is_theme_cake && availableFlavors.length > 0) && <h2 className="font-outfit font-bold lg:text-xl text-base text-[#303030] tracking-tight">Add Customization</h2>;
    $[0] = availableFlavors;
    $[1] = product?.has_eggless_option;
    $[2] = product?.is_theme_cake;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== formData || $[5] !== product?.has_eggless_option || $[6] !== toggleEggless) {
    t2 = product?.has_eggless_option && <div className="flex items-center"><Button className={`px-6 py-2.5 rounded-xl font-medium transition-all duration-300 ${formData.isEggless ? "bg-[#037A6A] text-white shadow-[0_4px_12px_rgba(3,122,106,0.3)] ring-2 ring-[#037A6A]/20" : "bg-white border border-[#E5E5E5] text-[#5A5A5A] hover:bg-gray-50 hover:border-gray-300 shadow-sm"}`} variant="outline" onClick={toggleEggless}><div className="flex items-center space-x-2"><div className={`w-3 h-3 rounded-full ${formData.isEggless ? "bg-white" : "bg-green-500"}`} /><span>Make it Eggless</span></div></Button></div>;
    $[4] = formData;
    $[5] = product?.has_eggless_option;
    $[6] = toggleEggless;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="space-y-4">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== availableFlavors || $[12] !== formData || $[13] !== handleFlavorChange || $[14] !== product?.is_theme_cake) {
    t4 = product?.is_theme_cake && availableFlavors.length > 0 && <div className="space-y-10"><CustomDropDown label="Flavour" placeholder="Select Flavour" options={availableFlavors} allowInput={false} onSelect={handleFlavorChange} selectedOption={formData.selectedFlavor} /></div>;
    $[11] = availableFlavors;
    $[12] = formData;
    $[13] = handleFlavorChange;
    $[14] = product?.is_theme_cake;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== formData || $[17] !== handleCustomizedNameChange || $[18] !== product?.metadata?.show_customized_name) {
    t5 = product?.metadata?.show_customized_name && <div className="hidden sm:block space-y-3 mt-4"><h2 className="text-[#303030] lg:text-lg text-xs font-normal font-outfit">Name on Product</h2><input type="text" value={formData.customizedName || ""} onChange={e => handleCustomizedNameChange?.(e.target.value)} placeholder="Enter name to customize..." className="w-full outline-none px-3 py-2 appearance-none border-[1px] rounded-md placeholder:text-sm text-sm border-[#D9D9D9]" maxLength={100} /></div>;
    $[16] = formData;
    $[17] = handleCustomizedNameChange;
    $[18] = product?.metadata?.show_customized_name;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== formData || $[21] !== handleMessageChange || $[22] !== product?.metadata?.show_custom_message) {
    t6 = product?.metadata?.show_custom_message && <MessageAndInstructions formData={formData} onMessageChange={handleMessageChange} />;
    $[20] = formData;
    $[21] = handleMessageChange;
    $[22] = product?.metadata?.show_custom_message;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== children || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t7 = <>{t3}{t4}{t5}{t6}{children}</>;
    $[24] = children;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
};
export default ProductForm;